/**
 * Labstep
 *
 * @module state/middleware/entity-page
 * @desc Middleware to handle page pagination actions
 */

import { POST_FILTER_PAGE_SIZE } from 'labstep-web/hoc/Params';
import type { Action } from 'labstep-web/models/action.model';
import { readEntitiesPage } from 'labstep-web/state/actions/entity';

export const entityPageMiddleware =
  (store: any) => (next: any) => (action: Action) => {
    const state = store.getState();

    if (action.type.startsWith('REQUEST_READ_NEXT_PAGE_')) {
      const {
        entityName,
        params,
        identifier,
        options,
        usePostFilter,
      }: any = action.meta;

      const readingState =
        state.entities?.[entityName]?.readingIds?.[identifier];

      if (!readingState) {
        return next({
          type: 'END_REQUEST_READ_NEXT_PAGE',
        });
      }

      const pages = Object.keys(readingState.pages);
      const lastPage = Number(pages[pages.length - 1]);
      const lastPageItems = readingState.pages[lastPage].items;

      if (!params.skip_total) {
        const lastPageNb = Number(pages[pages.length - 1]);
        const totalItems = readingState.total;
        const pageSize = params.count;
        const pageFilled = pages.length > 0 ? pages.length - 1 : 0;

        const totalRead =
          pageFilled * pageSize + lastPageItems.length;

        const remainingItemsToReadOnPage =
          pageSize - lastPageItems.length;

        if (
          totalRead < totalItems ||
          lastPage < readingState.totalPages
        ) {
          return next(
            readEntitiesPage(
              entityName,
              params,
              remainingItemsToReadOnPage
                ? lastPageNb
                : lastPageNb + 1,
              options,
              usePostFilter,
            ),
          );
        }
      } else if (
        lastPageItems.length >=
        (usePostFilter ? POST_FILTER_PAGE_SIZE : params.count)
      ) {
        return next(
          readEntitiesPage(
            entityName,
            params,
            lastPage + 1,
            options,
            usePostFilter,
          ),
        );
      }

      if (options?.onEnd) {
        options.onEnd();
      }

      return next({
        type: 'END_REQUEST_READ_NEXT_PAGE',
      });
    }

    return next(action);
  };
